<!--Contact-->
<!-- <section class="overview-block-ptb blue-bg text-center iq-font-white ">
  <div class="container">
    <h2 class="iq-tw-6 iq-pb-20 iq-font-white">Get Started Today</h2>
    <p>Simply dummy text of the printing and typesetting industry. Lorem Ipsum has been</p>
    <a href="javascript:void(0)" class="button bt-black iq-mt-10">Let's Started</a>
  </div>
</section> -->
<!--Contact end-->

<!-- Footer Info -->
<section id="contact-us" class="footer-info white-bg">
  <div class="container">
     <div class="row justify-content-end">
        <div class="col-md-6 col-lg-4">
           <div class="iq-get-in">
              <h4 class="iq-tw-7 iq-mb-20">Get in Touch</h4>
              <app-contact-form></app-contact-form>
           </div>
        </div>
     </div>
  </div>
  <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.840108181602!2d144.95373631539215!3d-37.8172139797516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65d4c2b349649%3A0xb6899234e561db11!2sEnvato!5e0!3m2!1sen!2sin!4v1497005461921" style="border:0" allowfullscreen></iframe>
</section>

<app-footer-style3>
  <p address>Via Sempione, 20092 Cinisello Balsamo MI, Italy</p>
  <p phone>+39 02 612 0111
     <br>Mon-Fri 9:00am - 5:00pm
     <br>
  </p>
  <p mail>info&#64;basilica.com
     <br>24 X 7 online support
     <br>
  </p>
  <!-- <ul links>
     <li><a href="javascript:void(0)"><i class="fab fa-twitter"></i></a></li>
     <li><a href="javascript:void(0)"><i class="fab fa-facebook"></i></a></li>
     <li><a href="javascript:void(0)"><i class="fab fa-google"></i></a></li>
     <li><a href="javascript:void(0)"><i class="fab fa-github"></i></a></li>
  </ul> -->
</app-footer-style3>
